import { useEffect } from 'react';
import { auth } from 'routes/config';
import { Navigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { queryClient } from 'providers/AllProviders';

export default function Logout() {
  useEffect(() => {
    const allCookies = Cookies.get();

    Object.keys(allCookies).forEach((cookieName) => {
      Cookies.remove(cookieName);
    });
    localStorage.clear();
  }, []);
  queryClient.removeQueries();
  return <Navigate to={`${auth.base}/${auth.login}`} replace />;
}
